import DashboardLayout from '@/pages/Layout/DashboardLayout'

import Home from '@/pages/Home'
import Register from '@/pages/Register'
import Login from '@/pages/Login'
// import Contact from '@/pages/Contact'
// import Promotions from '@/pages/Promotions'

import Play from '@/pages/Play'
import Referral from '@/pages/Referral'


import Bet from '@/pages/Bet'
import BetCasino from '@/pages/Bet/Casino'
import BetFishing from '@/pages/Bet/Fishing'
import BetSlot from '@/pages/Bet/Slot'
import BetKeno from '@/pages/Bet/Keno'
import BetCockFighting from '@/pages/Bet/CockFighting'
import BetSport from '@/pages/Bet/Sport'

import Menu from '@/pages/Menu'
import Account from '@/pages/Account'
import AccountAccount from '@/pages/Account/Account'
import AccountBalance from '@/pages/Account/Balance'
import AccountPromotions from '@/pages/Account/Promotions'
import AccountChangePassword from '@/pages/Account/ChangePassword'
import AccountDeposit from '@/pages/Account/Deposit'
import AccountWithdraw from '@/pages/Account/Withdraw'
import AccountTransaction from '@/pages/Account/Transaction'

import Page from '@/pages/Page'
import PagePromotions from '@/pages/Page/Promotions'
import PageHowToPlay from '@/pages/Page/HowToPlay'
import PageTerms from '@/pages/Page/Terms'
import PageContact from '@/pages/Page/Contact'
import PageDepositWithdraw from '@/pages/Page/DepositWithdraw'
import PageOpenAccount from '@/pages/Page/OpenAccount'

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/register',
		name: 'Register',
		component: Register,
	},
	{
		path: '/login',
		name: 'Login',
		component: Login,
	},
	{
		path: '/bet',
		name: 'Bet',
		component: Bet,
		children: [
			{
				path: 'casino',
				name: 'BetCasino',
				component: BetCasino,
			},
			{
				path: 'fishing',
				name: 'BetFishing',
				component: BetFishing,
			},
			{
				path: 'slot',
				name: 'BetSlot',
				component: BetSlot,
			},
			{
				path: 'keno',
				name: 'BetKeno',
				component: BetKeno,
			},
			{
				path: 'cock_fighting',
				name: 'BetCockFighting',
				component: BetCockFighting,
			},
			{
				path: 'sport',
				name: 'BetSport',
				component: BetSport,
			},
		]
	},
	{
		path: '/account',
		name: 'Account',
		component: Account,
		children: [
			{
				path: '',
				name: 'AccountAccount',
				component: AccountAccount,
			},
			{
				path: 'balance',
				name: 'AccountBalance',
				component: AccountBalance,
			},
			{
				path: 'promotions',
				name: 'AccountPromotions',
				component: AccountPromotions,
			},
			{
				path: 'deposit',
				name: 'AccountDeposit',
				component: AccountDeposit,
			},
			{
				path: 'withdraw',
				name: 'AccountWithdraw',
				component: AccountWithdraw,
			},
			{
				path: 'change_password',
				name: 'AccountChangePassword',
				component: AccountChangePassword,
			},
			{
				path: 'transaction',
				name: 'AccountTransaction',
				component: AccountTransaction,
			},
		]
	},
	{
		path: '/account_menu',
		name: 'AccountMenu',
		component: Menu,
	},
	{
		path: '/page',
		name: 'Page',
		component: Page,
		children: [
			{
				path: 'promotions',
				name: 'PagePromotions',
				component: PagePromotions,
			},
			{
				path: 'contact',
				name: 'PageContact',
				component: PageContact,
			},
			{
				path: 'how-to-play',
				name: 'PageHowToPlay',
				component: PageHowToPlay,
			},
			{
				path: 'deposit-withdraw',
				name: 'WithdrawWithdraw',
				component: PageDepositWithdraw,
			},
			{
				path: 'open-account',
				name: 'PageOpenAccount',
				component: PageOpenAccount,
			},
			{
				path: 'terms-conditions',
				name: 'PageTerms',
				component: PageTerms,
			},
		]
	},
	{
		path: '/play/:hash_id',
		name: 'Play',
		component: Play,
	},
	{
		path: '/r/:hash_id',
		name: 'Referral',
		component: Referral,
	},
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js